import axios from "axios";
import {
    ICloudFileDatabasePage,
    ICloudFolder,
    IMyDataImportResult,
    IPushpin,
    IPushpinType,
    IServiceResult,
    IStore,
    IStoreType,
    ITerritory,
    ITerritoryType,
    ICloudFile, ITargetMarketDeveloperType, ITargetMarketLocation,
} from "../../Models/Models";
import { IMyDataAxios } from "../index";
import { IStoreUpdateAuditResult } from "../../Models/IStoreUpdateAuditResult";

export class MyDataAxios implements IMyDataAxios {
    /*******Cloud Icons*******/
    public GetCloudIcons(url): Promise<IServiceResult<any>> {
        const promise = new Promise<IServiceResult<any>>((resolve, reject) => {
            axios.get<IServiceResult<any>>(url).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
        return promise;
    }
    /*******IMPORT*******/
    public SubmitImport(data, url): Promise<IServiceResult<IMyDataImportResult>> {
        const promise = new Promise<IServiceResult<IMyDataImportResult>>(
            (resolve, reject) => {
                axios.post<IServiceResult<IMyDataImportResult>>(url, data).then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            }
        );
        return promise;
    }

    public SubmitAudit(
        data,
        url
    ): Promise<IServiceResult<IStoreUpdateAuditResult>> {
        const promise = new Promise<IServiceResult<IStoreUpdateAuditResult>>(
            (resolve, reject) => {
                axios.post<IServiceResult<IStoreUpdateAuditResult>>(url, data).then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            }
        );

        return promise;
    }

    public DeleteCloudFolder(data): Promise<IServiceResult<ICloudFolder>> {
        const promise = new Promise<IServiceResult<ICloudFolder>>(
            (resolve, reject) => {
                axios
                    .post<IServiceResult<ICloudFolder>>(data.url, {
                        fullPath: data.fullPath,
                    })
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );
        return promise;
    }

    public AddCloudFolder(data): Promise<IServiceResult<ICloudFolder>> {
        const promise = new Promise<IServiceResult<ICloudFolder>>(
            (resolve, reject) => {
                axios
                    .post<IServiceResult<ICloudFolder>>(data.url, {
                        parentFullPath: data.parentFullPath,
                        name: data.name,
                    })
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );
        return promise;
    }

    public UpdateCloudFile(data): Promise<IServiceResult<ICloudFile>> {
        const promise = new Promise<IServiceResult<ICloudFile>>(
            (resolve, reject) => {
                axios
                    .post<IServiceResult<ICloudFile>>(data.url, data.file)
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );
        return promise;
    }

    public DeleteCloudFile(data): Promise<IServiceResult<ICloudFolder>> {
        const promise = new Promise<IServiceResult<ICloudFolder>>(
            (resolve, reject) => {
                axios
                    .post<IServiceResult<ICloudFolder>>(data.url, {
                        fullPath: data.fullPath,
                    })
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );
        return promise;
    }

    /*******STORES*******/
    //StoreTypes
    public GetStoreTypes(): Promise<IServiceResult<IStoreType>> {
        const promise = new Promise<IServiceResult<IStoreType>>(
            (resolve, reject) => {
                axios
                    .get<IServiceResult<IStoreType>>("/DataForge/Stores/Types", {})
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );
        return promise;
    }

    //StoreData
    public GetStoreData(data): Promise<IServiceResult<IStore>> {
        const promise = new Promise<IServiceResult<IStore>>((resolve, reject) => {
            axios
                .post<IServiceResult<IStore>>("/DataForge/Stores/Data", {
                    storeTypeId: data.type.id,
                    filters: data.filters,
                    rowStart: data.rowStart,
                    rowEnd: data.rowEnd,
                    sortColumn: data.sortColumn !== "" ? data.sortColumn : "",
                    sortDirection: data.sortDirection !== "" ? data.sortDirection : "",
                })
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
        return promise;
    }

    /*******PUSHPINS*******/
    //PushpinTypes
    public GetPushpinTypes(): Promise<IServiceResult<IPushpinType>> {
        const promise = new Promise<IServiceResult<IPushpinType>>(
            (resolve, reject) => {
                axios
                    .get<IServiceResult<IPushpinType>>("/DataForge/Pushpins/Types", {})
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );
        return promise;
    }

    //PushpinData
    public GetPushpinData(data): Promise<IServiceResult<IPushpin>> {
        const promise = new Promise<IServiceResult<IPushpin>>((resolve, reject) => {
            if (!data.type.typeID && data.type.id) {
                data.type.typeID = data.type.id;
            }
            axios
                .post<IServiceResult<IPushpin>>("/DataForge/Pushpins/Data", {
                    pushpinTypeID: data.type.typeID,
                    filters: data.filters,
                    rowStart: data.rowStart,
                    rowEnd: data.rowEnd,
                    collaborate: data.collaborate,
                    sortColumn: data.sortColumn !== "" ? data.sortColumn : "",
                    sortDirection: data.sortDirection !== "" ? data.sortDirection : "",
                })
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
        return promise;
    }

    /*******TERRITORIES*******/
    //TerritoryTypes
    public GetTerritoryTypes(): Promise<IServiceResult<ITerritoryType>> {
        const promise = new Promise<IServiceResult<ITerritoryType>>(
            (resolve, reject) => {
                axios
                    .get<IServiceResult<ITerritoryType>>(
                        "/DataForge/Territories/Types",
                        {}
                    )
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );
        return promise;
    }

    //TerritoryData
    public GetTerritoryData(data): Promise<IServiceResult<ITerritory>> {
    //Sometimes the ID comes down as typeID, sometimes as id. I don't freakin know.
        if (!data.type.typeID && data.type.id) {
            data.type.typeID = data.type.id;
        }

        const promise = new Promise<IServiceResult<ITerritory>>(
            (resolve, reject) => {
                axios
                    .post<IServiceResult<ITerritory>>("/DataForge/Territories/Data", {
                        territoryTypeID: data.type.typeID,
                        filters: data.filters,
                        rowStart: data.rowStart,
                        rowEnd: data.rowEnd,
                        collaborate: data.collaborate,
                        sortColumn: data.sortColumn !== "" ? data.sortColumn : "",
                        sortDirection: data.sortDirection !== "" ? data.sortDirection : "",
                    })
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );
        return promise;
    }

    /*******AREAS OF INTEREST*******/
    //AreasOfInterestPointTypes
    public GetAreasOfInterestPointTypes(): Promise<IServiceResult<ICloudFolder>> {
        const promise = new Promise<IServiceResult<ICloudFolder>>(
            (resolve, reject) => {
                axios
                    .get<IServiceResult<ICloudFolder>>(
                        "/DataForge/AreasOfInterest/Points",
                        {}
                    )
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );
        return promise;
    }

    //AreasOfInterestPointData
    public GetAreasOfInterestPointData(
        data
    ): Promise<
    IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>
  > {
        const promise = new Promise<
      IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>
    >((resolve, reject) => {
        axios
            .post<
          IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>
        >("/DataForge/AreasOfInterest/PointData", {
            fullPath: data.type.fullPath,
            filters: data.filters,
            rowStart: data.rowStart,
            rowEnd: data.rowEnd,
            sortColumn:
            data.sortColumn !== ""
                ? data.sortColumn != null
                    ? data.sortColumn.toUpperCase()
                    : null
                : "",
            sortDirection: data.sortDirection !== "" ? data.sortDirection : "",
        })
            .then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
    });
        return promise;
    }

    //AreasOfInterestShapeTypes
    public GetAreasOfInterestShapeTypes(): Promise<IServiceResult<ICloudFolder>> {
        const promise = new Promise<IServiceResult<ICloudFolder>>(
            (resolve, reject) => {
                axios
                    .get<IServiceResult<ICloudFolder>>(
                        "/DataForge/AreasOfInterest/Shapes",
                        {}
                    )
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );
        return promise;
    }

    //AreasOfInterestShapeData
    public GetAreasOfInterestShapeData(
        data
    ): Promise<
    IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>
  > {
        const promise = new Promise<
      IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>
    >((resolve, reject) => {
        axios
            .post<
          IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>
        >("/DataForge/AreasOfInterest/ShapeData", {
            fullPath: data.type.fullPath,
            filters: data.filters,
            rowStart: data.rowStart,
            rowEnd: data.rowEnd,
            sortColumn:
            data.sortColumn !== ""
                ? data.sortColumn != null
                    ? data.sortColumn.toUpperCase()
                    : null
                : "",
            sortDirection: data.sortDirection !== "" ? data.sortDirection : "",
        })
            .then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
    });
        return promise;
    }

    /*******RESULTS*******/
    //ResultsPointTypes
    public GetResultsPointTypes(): Promise<IServiceResult<ICloudFolder>> {
        const promise = new Promise<IServiceResult<ICloudFolder>>(
            (resolve, reject) => {
                axios
                    .get<IServiceResult<ICloudFolder>>("/DataForge/Results/Points", {})
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );
        return promise;
    }

    //ResultsPointData
    public GetResultsPointData(
        data
    ): Promise<
    IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>
  > {
        const promise = new Promise<
      IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>
    >((resolve, reject) => {
        axios
            .post<
          IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>
        >("/DataForge/Results/PointData", {
            fullPath: data.type.fullPath,
            filters: data.filters,
            rowStart: data.rowStart,
            rowEnd: data.rowEnd,
            sortColumn:
            data.sortColumn !== ""
                ? data.sortColumn != null
                    ? data.sortColumn.toUpperCase()
                    : null
                : "",
            sortDirection: data.sortDirection !== "" ? data.sortDirection : "",
        })
            .then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
    });
        return promise;
    }

    //ResultsShapeTypes
    public GetResultsShapeTypes(): Promise<IServiceResult<ICloudFolder>> {
        const promise = new Promise<IServiceResult<ICloudFolder>>(
            (resolve, reject) => {
                axios
                    .get<IServiceResult<ICloudFolder>>("/DataForge/Results/Shapes", {})
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );
        return promise;
    }

    //ResultsShapeData
    public GetResultsShapeData(
        data
    ): Promise<
    IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>
  > {
        const promise = new Promise<
      IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>
    >((resolve, reject) => {
        axios
            .post<
          IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>
        >("/DataForge/Results/ShapeData", {
            fullPath: data.type.fullPath,
            filters: data.filters,
            rowStart: data.rowStart,
            rowEnd: data.rowEnd,
            sortColumn:
            data.sortColumn !== ""
                ? data.sortColumn != null
                    ? data.sortColumn.toUpperCase()
                    : null
                : "",
            sortDirection: data.sortDirection !== "" ? data.sortDirection : "",
        })
            .then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
    });
        return promise;
    }

    /*******TARGET MARKETS*******/
    //TargetMarketTypes
    public GetTargetMarkets(): Promise<IServiceResult<ITargetMarketDeveloperType>> {
        return new Promise<IServiceResult<ITargetMarketDeveloperType>>((resolve, reject) => {
            axios
                .get<IServiceResult<ITargetMarketDeveloperType>>("/TargetMarket/GetByDeveloper")
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => reject(error));
        });
    }

    //TargetMarketData
    public GetTargetMarketData(data): Promise<IServiceResult<ITargetMarketLocation>> {
        return new Promise<IServiceResult<ITargetMarketLocation>>((resolve, reject) => {
            axios.post<IServiceResult<ITargetMarketLocation>>("/DataForge/TargetMarket/Data", {
                DeveloperId: data.type.developerId,
                TypeId: data.type.typeId,
                RowStart: data.rowStart,
                RowEnd: data.rowEnd,
                SortColumn: data.sortColumn ? data.sortColumn : "locationName",
                SortDirection: data.sortDirection ? data.sortDirection : "ASC"
            })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.error("Error fetching target market data:", error);
                    reject(error);
                });
        });
    }

    public GetMyDataConstants(): Promise<IServiceResult<any>> {
        const promise = new Promise<IServiceResult<any>>((resolve, reject) => {
            axios
                .get<IServiceResult<any>>("/DataForge/Import/Constants", {})
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
        return promise;
    }
    
}
